import { useEffect } from "react";
import type { TypedWrappedFieldProps } from "redux-form";

import type { OptionBase } from "@braintrust/braintrust-ui-components";
import { RANGE_VALUE } from "@js/apps/jobs/apps/create-job/constants";
import { OptionTileButtons } from "@js/components/option-tile-buttons";

import { RatePopover } from "./rate-popover";

type RateCustomFieldProps = {
  min_rate: TypedWrappedFieldProps<string>;
  max_rate: TypedWrappedFieldProps<string>;
  hourly_rate: TypedWrappedFieldProps<string>;
  rateOptions: OptionBase<string>[];
  custom_min_rate: TypedWrappedFieldProps<string>;
  custom_max_rate: TypedWrappedFieldProps<string>;
};

export const RateCustomField = ({
  min_rate,
  max_rate,
  hourly_rate,
  rateOptions,
  custom_min_rate,
  custom_max_rate,
}: RateCustomFieldProps) => {
  const handleClick = (value: string | null): void => {
    hourly_rate.input.onChange(value);
  };

  const isRangeSelected = hourly_rate.input.value === RANGE_VALUE;

  useEffect(() => {
    if (
      isRangeSelected &&
      min_rate.input.value !== custom_min_rate.input.value
    ) {
      min_rate.input.onChange(custom_min_rate.input.value);
    }

    if (
      isRangeSelected &&
      max_rate.input.value !== custom_max_rate.input.value
    ) {
      max_rate.input.onChange(custom_max_rate.input.value);
    }
  }, [custom_min_rate, custom_max_rate, isRangeSelected, max_rate, min_rate]);

  return (
    <div>
      <OptionTileButtons
        value={hourly_rate.input.value}
        onChange={(rate) => handleClick(rate)}
        options={rateOptions}
        renderCustomOptionButton={(props) => {
          return (
            <RatePopover
              {...props}
              onClick={() => {
                if (props?.onClick) props.onClick();
                hourly_rate.input.onChange(RANGE_VALUE);
                min_rate.input.onChange(custom_min_rate.input.value);
                max_rate.input.onChange(custom_max_rate.input.value);
              }}
              isRangeSelected={isRangeSelected}
              min_rate={custom_min_rate}
              max_rate={custom_max_rate}
            />
          );
        }}
      />
    </div>
  );
};
